// eventCache.js - 全局事件缓存与预加载逻辑

import { parseEvents } from '../components/TIMEBAR/parseEvents';
import { loadCsvFile } from '../components/TIMEBAR/robotEvents'; // 你已有的内部函数

// 全局缓存：保存解析后的事件
const parsedEventCache = {
  day: {},
  night: {}
};

// 异步预加载所有事件数据（调用一次就够）
export const preloadAllEvents = async (robotIds = [1,2,3,4,5,6,7,8,9,10], timeframes = ['11AM', '6PM']) => {
  const timeKeyMap = {
    '11AM': 'day',
    '6PM': 'night'
  };

  for (const timeframe of timeframes) {
    const timeKey = timeKeyMap[timeframe];

    for (const robotId of robotIds) {
      const csv = await loadCsvFile(robotId, timeKey); // 加载 csv
      await new Promise(resolve => {
        parseEvents(csv, (parsed) => {
          parsedEventCache[timeKey][robotId] = parsed; // 缓存 parse 后的事件
          resolve();
        });
      });
    }
  }

  console.log("✅ All robot events loaded and cached.");
};

// 获取某个 robot 的事件（已经 parse 好）
export const getParsedEvents = (robotId, timeframe = '11AM') => {
  const timeKey = timeframe === '11AM' ? 'day' : 'night';
  return parsedEventCache[timeKey]?.[robotId] || [];
};
